import { render } from "./SlotParentValue.vue?vue&type=template&id=41a65844&scoped=true"
import script from "./SlotParentValue.vue?vue&type=script&lang=js"
export * from "./SlotParentValue.vue?vue&type=script&lang=js"

import "./SlotParentValue.vue?vue&type=style&index=0&id=41a65844&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a65844"]])

export default __exports__